import type { Loan } from '@/types'
import type { PropertyProfile } from '@/types/propertyProfile'
import { ANTARCTICA_DEALS } from '@/data/clientMockData'
import { COMMAND_CENTER_LOANS } from '@/data/commandCenterLoans'
import { buildPropertyProfileFromLoan } from '@/data/propertyProfileFromLoan'

/** Full curated profiles in PropertyProfileDialog — do not auto-overwrite. */
const STATIC_ANTARCTICA_DETAIL_IDS = new Set([
  'ALG-1001',
  'ALG-1003',
  'ALG-1004',
  'ALG-1005',
  'ALG-1007',
  'ALG-1011',
])

function entriesFromLoans(loans: Loan[], commandCenter: boolean): [string, PropertyProfile][] {
  return loans.map((loan) => [loan.id, buildPropertyProfileFromLoan(loan, commandCenter)])
}

export const ANTARCTICA_GAP_PROPERTY_PROFILES: Record<string, PropertyProfile> = Object.fromEntries(
  entriesFromLoans(
    ANTARCTICA_DEALS.filter((d) => !STATIC_ANTARCTICA_DETAIL_IDS.has(d.id)),
    false,
  ),
)

export const COMMAND_CENTER_PROPERTY_PROFILES: Record<string, PropertyProfile> = Object.fromEntries(
  entriesFromLoans(COMMAND_CENTER_LOANS, true),
)
